import { useEffect, useState } from "react";

interface useIntersectionObserverProps extends IntersectionObserverInit {
  freezeOnceVisible?: boolean;
}

export default function useIntersectionObserver(
  element: Element | null,
  {
    threshold = 0,
    root = null,
    rootMargin = `${window.innerHeight / 3}px`,
    freezeOnceVisible = false,
  }: useIntersectionObserverProps
): IntersectionObserverEntry | undefined {
  const [entry, setEntry] = useState<IntersectionObserverEntry>();

  const frozen = entry?.isIntersecting && freezeOnceVisible;
  const updateEntry = ([entry]: IntersectionObserverEntry[]): void => {
    setEntry(entry);
  };

  useEffect(() => {
    if (!element) return;

    const hasIOSupport = !!window.IntersectionObserver;
    if (!hasIOSupport || frozen) return;

    const observer = new IntersectionObserver(updateEntry, {
      threshold,
      root,
      rootMargin,
    });

    observer.observe(element);

    return () => {
      observer.unobserve(element);
      observer.disconnect();
    };
  }, [element, threshold, root, rootMargin, frozen]);

  return entry;
}
